import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { BrowserStorageService } from '@app/utils/services/browser-storage.service';
import { BackOfficeAuthService } from '@app/backOffice/services/back-office-auth.service';

export const backOfficeAuthGuard: CanActivateFn = () => {
  const browserStorage = inject(BrowserStorageService);
  const authService = inject(BackOfficeAuthService);
  const router = inject(Router);

  const token = browserStorage.getSessionStorageItem('bo_access');
  if (!token) {
    router.navigate(['/internal/ops/v2/review/compliance/login']);
    return false;
  }

  // Bloquear acceso al backoffice si el usuario esta en flujo de recuperacion de contraseña
  if (authService.isInRecoveryFlow()) {
    router.navigate(['/internal/ops/v2/review/compliance/reset-password']);
    return false;
  }

  return true;
};
